import React, { useState, useEffect } from 'react'
import { projectFirestore } from '../firebase/config';
import AnnouncementBar from './AnnouncementBar';
import useSections from '../hooks/useSections';

import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container'
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';


const Header = () => {
    const [siteSettings, setSiteSettings] = useState({});
    const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
    const { sections } = useSections();
    const gallerySections = sections.filter(s => s.enabled !== false && s.key !== 'images');

    useEffect(() => {
        const unsub = projectFirestore.collection('settings').doc('site')
            .onSnapshot((doc) => {
                if (doc.exists) setSiteSettings(doc.data());
            });
        return () => unsub();
    }, []);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
        localStorage.setItem('darkMode', darkMode);
    }, [darkMode]);

    const siteTitle = siteSettings.siteTitle || 'حكاية ضوء';
    const logoSrc = darkMode && siteSettings.logoDarkUrl
        ? siteSettings.logoDarkUrl
        : (siteSettings.logoUrl || '/logo.svg');
    const bannerSrc = siteSettings.bannerUrl || 'b.jpg';
    const hasCustomDarkLogo = darkMode && siteSettings.logoDarkUrl;

    useEffect(() => {
        document.title = siteTitle;
    }, [siteTitle]);

    return (
<header>
<AnnouncementBar />
<Navbar className='sticky-top navbar-upgraded' expand="lg" >
  <Container>
  <Navbar.Brand href="/">
        <img
            alt={siteTitle}
            src={logoSrc}
            width="80"
            height="55"
            className={`d-inline-block align-top${hasCustomDarkLogo ? ' has-dark-logo' : ''}`}
        />
        <div className="d-none d-md-flex flex-column justify-content-center">
            <span className="site-title">{siteTitle}</span>
            <small style={{fontSize: 10, color: 'var(--text-muted)', letterSpacing: 1, marginTop: -2}}>Story of Light</small>
        </div>
    </Navbar.Brand>
    <div className="d-flex align-items-center d-lg-none gap-1">
        <button className="dark-toggle" onClick={() => setDarkMode(!darkMode)}
            title={darkMode ? 'الوضع النهاري' : 'الوضع الليلي'}>
            {darkMode ? '☀️' : '🌙'}
        </button>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
    </div>
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav className="me-auto">
        <Nav.Link href="/" className='widget20'><i className="fas fa-home"></i> الرئيسية</Nav.Link>

        <NavDropdown title={<span><i className="fas fa-images" style={{color:'var(--accent)', marginLeft:4}}></i> المعرض</span>} className='widget20' id="basic-nav-dropdown" size='lg'> 
            <NavDropdown.Item href="gallery" className='widget15'><i className="fas fa-th me-2"></i> الصور</NavDropdown.Item>
            {gallerySections.map(s => (
                <NavDropdown.Item key={s.key} href={s.key} className='widget15'>{s.label}</NavDropdown.Item>
            ))}
        </NavDropdown>

        <Nav.Link href="ai-generator" className='widget20'><i className="fas fa-magic"></i> توليد بالذكاء</Nav.Link>

        <Nav.Link href="contact-us" className='widget20'><i className="fas fa-comment-alt"></i> تواصل معنا</Nav.Link>
        <Nav.Link href="about-us" className='widget20'><i className="fas fa-info-circle"></i> عن الموقع</Nav.Link>
        <Nav.Link href="goals" className='widget20'><i className="fas fa-bullseye"></i> الاهداف</Nav.Link>
        <Nav.Link href="news" className='widget20'><i className="fas fa-rss"></i> الاخبار</Nav.Link>

    </Nav>
    <button className="dark-toggle d-none d-lg-flex" onClick={() => setDarkMode(!darkMode)}
        title={darkMode ? 'الوضع النهاري' : 'الوضع الليلي'}>
        {darkMode ? '☀️' : '🌙'}
    </button>
    </Navbar.Collapse>  
    </Container>
</Navbar>


<div className='hero-banner'>
        <img src={bannerSrc} alt={siteTitle} />
        <div className='hero-overlay'>
            <h1>{siteTitle}</h1>
            <hr className='hero-divider' />
            <p className='hero-subtitle'>معرض الصور الفوتوغرافية</p>
        </div>
    </div>


</header>
        )
}

export default Header